import { observable, action, computed } from 'mobx';

import CHARACTERS from '../data/characters';

class Character {

    @observable
    _character = 1;
    
    @action
    setCharacter(character) {
        this._character = character;
    }

    @computed
    get character() {
        const character = this.characters.find((character) =>  character.id === this._character);
        return Object.assign({}, character);
    }

    @computed
    get characters() {
        return CHARACTERS;
    }
    

}

export default new Character();
